<template>
    <div class="inner">
        <strong>CONTENTS</strong>
        <div class="side_block">
            <div v-for="category in categoryList" :key="category.webzine_category_code">
                <b>{{ category.webzine_category_name }}</b>
                <ul>
                    <li v-for="article in getArticleList(category.webzine_category_code)" :key="article.article_id">
                        <a href="#" @click="selectArticle(article.article_id)">
                            <div class="thumb">
                                <div :style="{ backgroundImage: 'url(' + getMainImage(article.mainImgFile) + ')' }"></div>
                            </div>
                            <div class="info">
                                <p class="article-title" :class="{active: article.article_id === selectedArticleId}">{{ article.article_title }}</p>
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
    name: "ArticleViewToc",
    mounted() {
  

    },
    computed: {
        ...mapGetters('webzineView', [
            'articleList',
            'categoryList',
            'webzine',
            'selectedArticleId',
            'selectedArticle',
            'selectedWebZineId',
            'mode'
        ])
    },
    
    methods: {
        ...mapActions('webzineView', [
            'getArticle'
        ]),
        ...mapMutations('webzineView', [
            'setSelectedArticleId'
        ]),
        getArticleList(categoryCode) {
            return this.articleList
                .filter(article => article.webzine_category_code === categoryCode)
                .map(article => article)
                .sort((a1, a2) => a1.priority - a2.priority);

        },
 

        selectArticle(article_id) {
            const url = `/${this.mode}/${this.selectedWebZineId}/articles/${article_id}`;
            this.$router.push(url);
        },

        getMainImage(mainImgFile) {
            if( mainImgFile ){
                return [
                    this.$baseURL
                    , 'image' + mainImgFile.server_path
                    , mainImgFile.new_name
                ].join('/');
            } else{
                return '';
            }
        },
    }
}
</script>

<style scoped>
.wz-article-toc {
    display: flex;
    max-width: 480px;
}

.wz-article-toc__con {
    width: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: auto;
}

.wz-article-toc h4 {
    margin: 10px 0;
}

.wz-article-toc h5 {
    margin: 0;
    padding: 10px 5px;
}

.article-title {
    cursor: pointer;
}

.article-title.active,
.article-title:hover {
    color: #009DDA !important;
}

.wz-publish-info {
    display: flex;
    flex-direction: column;
    padding: 25px 30px;
}

.wz-publish-info .info {
    display: flex;
    padding: 4px 0;
}

.wz-publish-info .info>span {
    display: block;
    padding: 0 3px;
}

.wz-publish-info .info>.title {
    font-weight: 300;
    font-size: 13px;
    min-width: 50px;
}

.wz-publish-info .info>.publish {
    word-break: break-all;
    white-space: pre-line;
    font-size: 12px;
}


.main-side-bar {
    display: flex;
    align-items: center;
    justify-content: center;
}


.main-side-bar>a {
    position: fixed;
    top: 0;
    left: 0;
    width: 70px;
    height: 100vh;
    color: #fff;
    writing-mode: tb-rl;
    text-align: center;
    line-height: 70px;
    font-size: 1rem;
    transition: 0.5s;
    text-decoration: none;
    background: linear-gradient(0deg, rgba(131, 58, 180, 1) 0%, rgba(253, 29, 29, 1) 50%, rgba(252, 176, 69, 1) 100%);
}

.main-side-bar>a:hover {
    text-decoration: none;
    transition: 0.5s;
    width: 70px;
    background: linear-gradient(0deg, rgba(63, 94, 251, 1) 0%, rgba(252, 70, 107, 1) 100%);
}

.main-side-bar img {
    width: 25px;
    margin-bottom: 10px;
    margin-right: 11px;
}

.main-side-bar>a>div {
    font-weight: 300;
    width: 500px;
    transform: rotate(90deg);
    text-align: center;
}
</style>
